<div class="main-wrapper">
	<div class="main-content">
		<!-- global markup for header -->
		<header #header class="header">
			<div class="content">
				<div class="header__block row">
					<div class="header__arrow col image no-print" (click)="goBack()">
						<img src="/assets/images/header/back-arrow.svg" alt="arrow" />
					</div>
					<div class="header__title col">{{ title$ | async }}</div>

					<div class="header__burger col image no-print" (click)="restart()" style="text-decoration: underline">
						<b> איפוס </b>
					</div>
				</div>
			</div>
			<div class="report-table__row no-print">
				<div class="header__search header__search_small relative" style="width: 99%; margin: auto; margin-top: 10px">
					<form [formGroup]="form">
						<input class="header__search-input" type="text" placeholder="חפש" formControlName="search" id="search-Input" style="text-align: center; direction: rtl" />
					</form>
					<button class="header__clear-icon" (click)="form.controls.search.reset()"></button>
				</div>
				<span class="absolute" style="left: 50%; transform: translateX(-50%); color: white; padding-top: 4px">מציג ( {{ totalDisplayed$ | async }} ) משימות</span>
			</div>
		</header>

		<!-- start markup for delete teuda confirmation popup -->

		<!-- markup for see teuda after teuda num press-->

		<div class="popup" *ngIf="(shouldDisplayPopup$ | async) && openedOrderSelected$ | async as openedOrder" style="z-index: 555">
			<div class="overlay" (click)="togglePopupState()"></div>
			<div class="product-detail__title">{{ openedOrder[0].ClientName }} - {{ openedOrder[0].OrderNum }}</div>
			<div class="product-detail-popup popup__content">
				<div class="popup__close" (click)="togglePopupState()" style="width: 30px; height: 30px; background-color: black"></div>
				<div class="product-detail__wrapper custom-scrollbar">
					<table>
						<tr>
							<th #teudotTableNames>שם פריט</th>
							<th>קוד פריט</th>
							<th>כמות</th>
							<th>מחיר</th>
							<th>הנחה</th>
						</tr>
						<tr *ngFor="let row of openedOrder">
							<td>{{ row.ProductName }}</td>
							<td>{{ row.ProductId }}</td>
							<td>{{ row.Quantitiy }}</td>
							<td>{{ row.Price }}</td>
							<td>{{ row.Discount }}</td>
						</tr>
					</table>
				</div>
			</div>
		</div>

		<!--  dashboard-tables markup  -->
		<section class="dashboard-tables" style="margin-top: 30px">
			<div class="content">
				<div class="dashboard-tables__wrapper">
					<!-- <table
						style="font-size: 17px; position: sticky; top: 130px; z-index: 999"
						class="filter-row no-print"
						[ngStyle]="{ 'z-index': (isLikutViewPopupOpenNewRoutes$ | async) || (isTruckLoadingPopupOpen$ | async) ? '99' : '999' }"
						*ngIf="!isTruckDistribution"
					>
						<tr>
							<th style="background-color: white; width: 150px"><b>סינון מתקדם</b></th>
						</tr>

						<tr>
							<td>
								<div class="justify-align-center gap">
									<div class="report-table__button" (click)="showFilterPopup = true"></div>
									<app-print-button></app-print-button>
									<button *ngIf="shouldShowExternalPrintButton$ | async" mat-raised-button (click)="sendExternalPrint()">שלח להדפסה</button>
								</div>
							</td>
						</tr>
					</table> -->

					<div class="dashboard-tables__row dashboard-tables__row_scroll margin-top">
						<!-- <div class="show-only-in-print" style="margin-bottom: 20px; font-size: larger; text-align: center" *ngIf="isLikut">
							{{ filterPrintDisplay$ | async }}
						</div> -->
						<b>
							<section class="sticky-headers">
								<table class="report-table__table" [ngStyle]="{ height: 'calc(99vh - ' + (0 || 0) + ')' }" cellspacing="0">
									<thead class="report-table__table-head" #thead>
										<tr>
											<th class="report-table__table-head-name width-60">תעודה</th>
											<th class="report-table__table-head-code">מפתח</th>
											<th class="report-table__table-head-quantity">שם</th>
											<th class="report-table__table-head-quantity">תאריך</th>
											<th class="report-table__table-head-quantity">סוג</th>
										</tr>
									</thead>
									<tbody #dynamicHeightTBody class="report-table__table-body dynamic-height">
										<tr class="clickable" *ngFor="let row of openOrdersDisplay$ | async" (click)="togglePopupState(row)">
											<td class="report-table__table-body-name width-60">{{ row[0].OrderNum }}</td>
											<td class="report-table__table-body-quantity">{{ row[0].ClientId }}</td>
											<td class="report-table__table-body-quantity">{{ row[0].ClientName }}</td>
											<td class="report-table__table-body-quantity">{{ row[0].OrderDate | date : 'dd/MM/yy' : 'GMT' }}</td>
											<td class="report-table__table-body-quantity">{{ row[0].OrderTypeName }}</td>
										</tr>
									</tbody>
								</table>
							</section>
						</b>
					</div>
				</div>
			</div>
		</section>
	</div>

	<!-- end main menu markup -->
</div>

<!-- start sort popup -->
<!-- <div class="popup" *ngIf="showFilterPopup">
	<div class="overlay"></div>
	<div class="popup__close" (click)="showFilterPopup = false" style="top: 2em; z-index: 1002; box-shadow: inset 0px 0px 2px, 0 0 3px 2px" [style.left]="windowWidth > 768 ? '43%' : '2em'"></div>
	<div class="report-table-popup report-table-popup_sort popup__content" style="overflow-y: scroll">
		<div class="report-table-popup__header">
			<div class="report-table-popup__header-title">סינון מתקדם</div>
		</div>
		<div class="report-table-popup__wrapper">
			<div class="report-table-popup__content">
				<div class="report-table-popup__row report-table-popup__row_space-between report-table-popup__row_no-border report-table-popup__row_padding"></div>
				<div class="report-table-popup__row report-table-popup__row_no-border report-table-popup__row_double">
					<ng-container *ngIf="!isConcentratedReport">
						<div class="report-table-popup__box">
							<span class="report-table-popup__content-title">בחירת תקופה</span>
							<div class="report-table-popup__row report-table-popup__row_padding-bottom">
								<label class="report-table-popup__label">
									<div class="report-table-popup__label-title report-table-popup__label-title_gray">מתאריך</div>
									<form [formGroup]="form">
										<input type="date" formControlName="FromDate" (change)="handleDateChange('from')" />
									</form>
								</label>
							</div>
							<div class="report-table-popup__row report-table-popup__row_padding-bottom">
								<label class="report-table-popup__label">
									<div class="report-table-popup__label-title report-table-popup__label-title_gray">עד תאריך</div>
									<form [formGroup]="form">
										<input type="date" formControlName="ToDate" (change)="handleDateChange('to')" />
									</form>
								</label>
							</div>
						</div>

						<ng-container *ngIf="!isNoStatus && !isAssignmentOfLikut">
							<div class="report-table-popup__box">
								<div class="report-table-popup__row report-table-popup__row_space-between report-table-popup__row_no-border">
									<span class="report-table-popup__content-title">מלקטים</span>
								</div>
								<div style="float: right; height: 75px">
									<form [formGroup]="form" style="width: 150px">
										<mat-form-field color="primary" appearance="fill" dir="rtl" style="transform: translateX(10%) scale(0.6); font-size: 22px">
											<mat-select formControlName="Agent" multiple>
												<mat-option *ngFor="let a of agentsToFilter" [value]="a">{{ a }}</mat-option>
											</mat-select>
										</mat-form-field>
									</form>
								</div>
							</div>
							<div class="report-table-popup__box">
								<div class="report-table-popup__row report-table-popup__row_space-between report-table-popup__row_no-border">
									<span class="report-table-popup__content-title">סטטוס</span>
								</div>
								<div style="float: right; height: 75px">
									<form [formGroup]="form" style="width: 150px">
										<mat-form-field color="primary" appearance="fill" dir="rtl" style="transform: translateX(10%) scale(0.6); font-size: 22px">
											<mat-select formControlName="Status" multiple>
												<mat-option *ngFor="let s of statusesToFilter" [value]="s">{{ s | taskText : 'likut' }}</mat-option>
											</mat-select>
										</mat-form-field>
									</form>
								</div>
							</div>
						</ng-container>
					</ng-container>
					<ng-container *ngIf="isConcentratedReport">
						<div class="report-table-popup__box">
							<div class="report-table-popup__row report-table-popup__row_space-between report-table-popup__row_no-border">
								<span class="report-table-popup__content-title">פילטר</span>
							</div>
							<div style="float: right; height: 75px; width: 150px">
								<form [formGroup]="form" style="width: 150px">
									<mat-form-field color="primary" appearance="fill" dir="rtl" style="transform: translateX(10%) scale(0.6); font-size: 22px">
										<mat-select formControlName="filterColumn" multiple>
											<mat-option *ngFor="let s of _likut.filters$ | async" [value]="s">{{ s }}</mat-option>
										</mat-select>
									</mat-form-field>
								</form>
							</div>
						</div>

						<div class="report-table-popup__box">
							<div class="report-table-popup__row report-table-popup__row_space-between report-table-popup__row_no-border">
								<span class="report-table-popup__content-title">פילטר2</span>
							</div>
							<div style="float: right; height: 75px; width: 150px">
								<form [formGroup]="form" style="width: 150px">
									<mat-form-field color="primary" appearance="fill" dir="rtl" style="transform: translateX(10%) scale(0.6); font-size: 22px">
										<mat-select formControlName="filterColumn2" multiple>
											<mat-option *ngFor="let s of _likut.filters2$ | async" [value]="s">{{ s }}</mat-option>
										</mat-select>
									</mat-form-field>
								</form>
							</div>
						</div>
					</ng-container>

					<div class="report-table-popup__box" *ngIf="shouldShowAreaColumnInNoStatus">
						<div class="report-table-popup__row report-table-popup__row_space-between report-table-popup__row_no-border">
							<span class="report-table-popup__content-title">אזור</span>
						</div>
						<div style="float: right; height: 75px">
							<form [formGroup]="form" style="width: 150px">
								<mat-form-field color="primary" appearance="fill" dir="rtl" style="transform: translateX(10%) scale(0.6); font-size: 22px">
									<mat-select formControlName="areas" multiple>
										<mat-option *ngFor="let area of areasToFilter" [value]="area">{{ area }}</mat-option>
									</mat-select>
								</mat-form-field>
							</form>
						</div>
					</div>
				</div>
				<div class="report-table-popup__button-wrapper">
					<button class="report-table-popup__button" [attr.disabled]="dateInvalid ? true : null" [ngClass]="{ darken: dateInvalid }" (click)="handleAdvancedSearch()">הצג תוצאות</button>
				</div>
			</div>
		</div>
	</div>
</div> -->
<!-- end sort popup -->

<!-- start clientcard popup -->

<!-- <div class="popup" *ngIf="shouldClientCardPopupShow" style="z-index: 556">
	<div class="overlay"></div>
	<div class="product-detail-popup popup__content fixed">
		<div class="product-detail__wrapper wrapper2">
			<div class="product-detail__item overflow" style="padding: 0">
				<div class="popup__close" (click)="toggleClientCardPopup()" style="width: 30px; height: 30px; background-color: black; position: fixed"></div>
				<app-clientcard></app-clientcard>
			</div>
		</div>
	</div>
</div> -->
